export function smartRoundUp(value: number, decimalPlaces: number = 2): number {
  const factor = Math.pow(10, decimalPlaces);
  const roundedValue = Math.round(value * factor) / factor;

  return Number(roundedValue.toFixed(decimalPlaces));
}